import React from 'react';
import classnames from 'classnames';

const inputName = (group, name) => {
  if (group === null || group === '') {
    return name;
  }

  return `${group}[${name}]`;
};

const TextAreaInput = (props) => {
  const {
    groupName,
    className,
    name,
    rows,
    onChange,
    value,
    placeholder,
    disabled,
  } = props;

  return (
    <textarea
      name={inputName(groupName, name)}
      rows={rows}
      onChange={onChange}
      placeholder={placeholder}
      className={classnames('form-control', className)}
      value={value || ''}
      disabled={disabled} />
  );
};

TextAreaInput.defaultProps = {
  rows: 3,
  groupName: 'parameters',
  name: '',
};

export default TextAreaInput;
